import type { I18n } from '@/typings/i18n'

const ja: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: 'ヒント',
    confirmButtonText: '確定',
    cancelButtonText: 'キャンセル',
    day: '日',
    people: '人',
    bindButtonText: 'バインド',
    help: 'ヘルプ',
    manageSubscription: 'サブスクリプションを管理 ',
    coupon: 'クーポンを確認',
    deleteMessage: '本当に削除しますか？',
    deleteButtonText: '削除',
    renameButtonText: '名前変更',
    downloadButtonText: 'ダウンロード',
    install: 'インストール',
    phoneNumberLabel: '携帯電話番号',
    verificationCodeLabel: '認証コード',
    sendButtonText: '送信',
    saveButtonText: '保存',
    download: 'ダウンロード',
    complete: '完了',
    adjustButtonText: '調整',
    eraser: '消しゴム',
    undo: '元に戻す',
    redo: 'やり直す',
    clear: 'クリア',
    noDataMessage: 'データなし',
    loading: '読み込み中',
    customize: 'カスタマイズ',
    referenceImage: '参考画像',
    styleImage: '款式画像',
    high: '高い',
    middle: '中間',
    low: '低い',
    big: '大きい',
    small: '小さい',
    select: '選択',
    upload: 'アップロード',
    colon: '：',
    uploadDesc: 'クリックまたはファイルをこの領域にドラッグしてアップロードしてください',
    generate: 'プレビュー',
    preview: '预览',
    magic: 'スマート',
    add: '追加',
    subtract: '削減',
    brush: 'ブラシ',
    part: '部分',
    commonlyUsed: '一般的な',
    recommend: 'おすすめ',
    termsOfService: 'サービス利用規約',
    userAgreement: 'ユーザー契約',
    privacyStatement: 'プライバシー声明',
    wechat: 'ウィーチャット',
    xiaohongshu: '小紅書',
    downloadClient: 'クライアントをダウンロード',
    ok: 'はい',
    and: 'および',
    language: '言語',
    copy: 'コピー',
    copyLink: 'リンクをコピー',
    signupTitle: '登録',
    signupTitleSuffix: 'LOOK AI リアルタイムファッションデザインツール',
    recentsTitle: '最近生成 - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: '次のステップ',
    accept: '受け入れる',
    reject: '拒否する',
    about: '概要',
    close: '閉じる',
    skip: 'スキップ',
    iKnow: 'わかりました'
  },
  system: {
    updateTip: '新しいバージョンがダウンロードされました。クリックして更新してください',
    updateMessage: 'アプリケーションを閉じて更新をインストールしてもよろしいですか？',
    drawingDownMessage: '機能はクライアントのダウンロードが必要です，',
    bonjourInstallTitle: 'Bonjour未インストール',
    bonjourInstallMessage1: '投屏接收サービスがインストールされていません。',
    bonjourInstallMessage2:
      ' 機能は正常に動作しません。投屏受信ツールをダウンロードしてインストールし、LOOKを再起動してください。',
    bonjourInstallMessage3:
      'ダウンロードがまだ機能しない場合は、「非表示」をクリックしてください。',
    bonjourUnavailableTitle: 'Bonjour未インストール',
    bonjourUnavailableMessage1: '投屏受信サービスがインストールされていません。',
    bonjourUnavailableMessage2: 'ビデオガイドに従って強力にアンインストールしてください。',
    bonjourUnavailableMessage3: '投屏受信サービスを再インストールしてLOOKを再起動してください。',
    bonjourUnavailableMessage4:
      'ダウンロード後もまだ機能しない場合は、Discordにアクセスしてください：',
    bonjourStartTitle: 'Bonjour未正常起動',
    bonjourStartMessage1:
      '投屏受信サービスが正常に起動していないことが検出されました。リアルタイムデザイン機能が正常に動作しません。ガイド手順に従って起動してください',
    bonjourStartMessage2: 'その後',
    bonjourStartMessage3: 'LOOKを再起動',
    bonjourStartMessage4: '1、システム設定を開き、「サービス」を検索してください',
    bonjourStartMessage5: '2、サービスでBonjourを右クリックし、「開始」を選択してください',
    bonjourStartMessage6: '3、LOOKを再起動して使用',
    bonjourStartMessage7: '再起動後もまだ機能しない場合は、Discordにアクセスしてください：',
    bonjourStartText: '正常に起動',
    bonjourUnavailable: '機能は正常に動作しません',
    bonjourDownload: 'Bonjour ダウンロード',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      '注意：投影受信サービスをインストールした場合でも、サービスがインストールされていないというプロンプトが繰り返し表示される場合は、投影受信サービスが完全にインストールされていない可能性があります。強力なアンインストールツールを使用して、BonjourとBonjour SDKの両方のアプリケーションをアンインストールしてから、投影受信サービスのインストールを再試行してください。',
    guideButtonText: '使い方ガイド',
    noImageMessage: '画像が選択されていません',
    aboutUsTitle: '私たちについて',
    weChatPublicAccountTitle: 'WeChat公式アカウント',
    error400: 'リクエストパラメータが正しくありません',
    error403: 'アクセス拒否',
    error404: 'リクエストアドレスが存在しません',
    error408: 'リクエストタイムアウト',
    error500: 'サーバー内部エラー',
    error501: 'サーバー未実装',
    error502: 'ゲートウェイエラー',
    error503: 'サービス利用不可 ',
    error504: 'ゲートウェイタイムアウト',
    copySuccess: 'コピー成功',
    copyError: 'コピー失敗：',
    browserTips:
      'より良い使用体験のために、Chromeブラウザを使用してアクセスするか、クライアントをダウンロードしてください，',
    serviceStopMessage:
      'あなたのPro訂閱は{date}に自動更新されませんでした。期限切れ未払いの場合、サービスは停止します。',
    renewalReminderMessage: '引き続き使用するには、次の手順を実行してください',
    paymentLink: 'サブスクリプションの支払いを完了するにはクリックしてください',
    updateTipsMessage:
      'LOOKは新しいバージョンを検出してアップデートをインストールするために自動的に終了します。',
    osVersionNotSupportedMessageWindows:
      'Windows 10 64ビット未満のオペレーティングシステムバージョンはサポートされておらず、使用体験に影響を与える可能性があります。オペレーティングシステムをアップグレードするか、ブラウザを使用してアクセスすることをお勧めします',
    osVersionNotSupportedMessageMacOS:
      'Mac OS 13未満のオペレーティングシステムバージョンはサポートされておらず、使用体験に影響を与える可能性があります。オペレーティングシステムをアップグレードするか、ブラウザを使用してアクセスすることをお勧めします',
    updatedDownloadMessage:
      '新しいバージョンを検出しました。自動で閉じてアップデートをインストールします',
    receiverConnectErrorMessage: 'スクリーンミラーリング受信端接続エラー：{message}',
    receiverStartErrorMessage: 'スクリーンミラーリング受信端起動エラー：{message}',
    macOSVersionErrorMessage:
      'スクリーンミラーリング受信端起動エラー：Mac OSのバージョンが低すぎます。オペレーティングシステムをアップグレードしてください。',
    airplayRTPErrorMessage:
      'AirPlayのスクリーンミラーリングでネットワークエラーが発生しました。ネットワーク接続を確認してから、LOOKを再起動してください。',
    networkDisconnectedMessage:
      'ネットワーク接続が断たれました。ネットワーク接続を確認して再試行してください。',
    networkReconnectedMessage:
      'ネットワークが再接続されました。ストリーミングを続行するには、LOOKを再起動してデバイスを再接続してください。',
    slogan1: 'AIリアルタイムファッションデザインツール',
    slogan2: 'リアルタイムでアイデアを実現！',
    slogan3: 'リアルタイムデザイン、リアルな結果',
    slogan4: 'スケッチから即座にレンダリング、複数のバリエーション生成',
    slogan5: 'スタイル融合、想像力を超える',
    slogan6: '部分調整、AIで精密制御',
    networkErrorMessage:
      '現在、ネットワークに接続されていません。デバイスのネットワーク設定を確認してください',
    serverErrorMessage: 'サーバーへのアクセスに失敗しました。後でもう一度お試しください',
    languageChangeMessage: 'この言語に切り替えるには再ログインが必要です。本当に切り替えますか？',
    downloadAppMessage:
      'アプリを初めてダウンロードしてログインすると、<br/><span style="font-weight: 700; font-size: 24px">追加で1日間の無料トライアル</span>が得られます',
    downloadButtonTextMac: 'macOS版をダウンロード',
    downloadButtonTextWindows: 'Windows版をダウンロード',
    consentTitle: 'Cookie通知',
    consentTips:
      'より良いサービスとパーソナライズされた体験を提供するために、当社はCookieおよび類似の技術を使用して、ウェブサイトのパフォーマンスを分析し、パーソナライズされた広告を表示し、ソーシャルメディア機能を提供します。「すべてのCookieを受け入れる」をクリックするか、このサイトの使用を継続することにより、より個別化された体験を提供するための分析用Cookieとトラッキング用Cookieの使用に同意したことになります。当社が使用するCookieについて詳しくは、<span style="font-weight: 700; text-decoration: underline; cursor: pointer">Cookie ポリシー</span>をご覧ください。',
    aboutTitle: 'LOOK デスクトップアプリ',
    currentVersion: 'バージョン',
    newVersion: '新しいバージョン',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: '更新をチェック',
    updateButtonText: 'バージョン {version} に更新',
    noUpdateMessage: '最新バージョンです',
    updateFailMessage: '更新失敗，LOOKを再起動して更新を再試行してください',
    appDownloadGuideTitle: 'LOOK デスクトップクライアントをダウンロード',
    appDownloadGuideSubTitle:
      'この機能は LOOK デスクトップクライアントをダウンロードして使用する必要があります。',
    realtimeDesignGuideTitle: 'Real-Time Designガイド',
    realtimeDesignGuideSubTitle1:
      'Real-Time Design機能は <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK デスクトップクライアントをダウンロードして使用する必要があります。',
    realtimeDesignGuideSubTitle2:
      ' <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate と <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK デスクトップクライアントを開き、チュートリアルに従ってスクリーンミラーリング接続を完了してください。',
    freeCountLimitDialogTitle: '生成制限に達しましたか？',
    freeCountLimitDialogDesc:
      'アプリを初めてダウンロードしてログインすると、<br/><span style="font-weight: 600; font-size: 24px">追加で1日間の無料トライアル</span>が得られます',
    freeCountLimitDialogDescMobile:
      '<span style="font-weight: 600">PCまたはmacOS</span>で<br/>アプリを初めてダウンロードしてログインすると、<br/><span style="font-weight: 600;font-size: 24px">追加で1日間の無料トライアル</span>が得られます',
    imageSizeTooLarge: '画像サイズは {size}MB を超えることはできません'
  },
  error: {
    invitationCodeUsed: '招待コードはすでに使用されています',
    invitationCodeInvalid: '招待コードが無効です',
    networkErrorTitle: 'ネットワークエラー',
    networkErrorMessage: 'サーバーに接続できません。ネットワーク接続を確認して再試行してください',
    retryButtonText: '再試行',
    upscaleScaleError:
      'アップスケールは許可されていません。より高い画像品質を解放するには、プランをアップグレードしてください。',
    campaignSystemError: 'システムエラー、後でもう一度お試しください',
    campaignUserAuthError: 'ユーザーの身分を取得できませんでした',
    campaignParamError: 'パラメータエラー',
    campaignQueryError: 'クエリエラー',
    campaignNotCompleted: '活動タスクが完了していません',
    campaignRewardAlreadyClaimed: '報酬はすでに受け取られています',
    campaignCouponNotAvailable: 'クーポンは使用できません',
    campaignUseCoupon: 'クーポンの使用に失敗しました',
    campaignAssignCoupon: 'クーポンの割り当てに失敗しました',
    userGoogleAuthFail: 'Google ログインに失敗しました',
    userNotSupportLoginType: 'サポートされていないログイン方式',
    userSystemError: 'システムエラー',
    userLoginError: 'ログインに失敗しました'
  },
  account: {
    logoutMessage: 'ログアウトしてもよろしいですか？',
    logoutButtonText: 'ログアウト',
    bindPhoneTitle: '携帯電話を紐付ける',
    bindPhoneSuccessMessage: '携帯電話の紐付けに成功しました',
    bindPhoneTips: '携帯番号を紐付けて無料会員を獲得',
    bindPhoneEmptyNumberMessage: '携帯電話番号を入力してください',
    bindPhoneErrorNumberMessage: '有効な携帯電話番号ではありません',
    bindPhoneVerificationCodeEmptyMessage: '認証コードを入力してください',
    getInvitationCodeErrorMessage: '招待コード情報の取得に失敗しました',
    trialDuration: '試用期間：',
    headerGiftText: 'クーポンを受け取る',
    headerOneDayGiftText: 'メンバーシップ{discount}%オフ',
    headerSubscribeGiftText: '今すぐ購読',
    invitePopoverTitle: '友達招待',
    invitePopoverDescTips:
      '新規ユーザーが携帯電話を紐付けると、新規ユーザーの招待が成功したと見なされます',
    invitePopoverMark: '<span>$15</span>&nbsp;バウチャーを獲得！',
    invitePopoverDesc:
      '友達を招待するごとに、サブスクリプション/更新に使用できる$15のバウチャーを受け取ります！友達は15日間の無料トライアルを受け取ります！',
    invitePopoverCodeShareTitle: 'スキャンしてシェア',
    invitePopoverCodeCopyTitle: '招待コードをコピー',
    invitePopoverShareCountText: '残りの招待数：',
    invitePopoverSubText: '使用状況に応じて招待コードが自動配布されます',
    invitePopoverGiftDaysText: '累積バウチャー：',
    invitePopoverBindPhoneMaskText: '携帯電話を紐付けてアクティベートし、招待枠を取得',
    phoneNumber: '携帯番号：',
    noMemberText: 'Free',
    memberExpireAtFormat: 'YYYY年MM月DD日',
    memberExpireAt: '有効期限：',
    memberUpgradeMainText: '4K画像の生成制限を引き上げる',
    memberUpgradeMainTextFirst: '50%オフを獲得！',
    memberUpgradeSubText: 'リアルタイムデザインの自由を実現！',
    memberUpgradeLinkTextActivate: '開通する',
    memberUpgradeLinkTextUpgrade: '昇格',
    memberUpgradeLinkTextGet: '取得する',
    memberUpgradeLinkTextManage: '管理',
    discordLoginTitle: 'LOOKを始める',
    discordLoginButtonText: 'Discordでログイン',
    discordLoginSubText1: 'サインアップすることで、LOOK AI アカウントが作成され、LOOK AI の ',
    discordLoginSubText2: ' に同意したことになります。',
    googleLoginButtonText: 'Googleでログイン',
    invitePageTitle: 'こんにちは、デザイナーさん',
    invitePageNicknamePlaceholder: 'ニックネーム',
    invitePageInvitationCodePlaceholder: '招待コード',
    invitePageSubmitButtonText: '使い始める',
    invitePageTips: '招待コードで<span style="font-weight: 700">追加の8日間無料トライアル</span>',
    invitePageInvitationCodeInvalid: '招待コード無効',
    hasInvitationCodeText: '招待コードを持っています',
    shareInvitationCodeText: `LOOK AIリアルタイムファッションデザインツール

💻 PCアクセス：https://app.lookfashion.ai
📱 現在、モバイルデバイスはサポートされていません

招待コード：{code}`,
    limitedTitle: '落ち着いて…',
    limitedSubject: '<span style="font-weight: 600">{name}</span>の生成制限に達しました。',
    limitedTime: 'あなたは {time} 後に続行できます。',
    limitedRealtimeDesignTime: 'リアルタイムデザインの使用制限に達しました。',
    upgradeTitle: '待つのに疲れましたか？',
    upgradeSubject:
      'メンバーシップをアップグレードして<span style="font-weight: 600">すぐに生成</span>！',
    upgradeButtonText: '今すぐアップグレード ',
    mergeAccount: 'これはあなたですか？',
    mergeAccountDesc: 'はい、アカウントを結合します',
    mergeAccountCancel: 'いいえ、ログインに戻ります',
    recentLoginText: '前回の'
  },
  project: {
    recentListTitle: '最近生成',
    collectListTitle: 'お気に入りリスト',
    projectListTitle: 'プロジェクトリスト',
    emptyMessage1: 'まだプロジェクトが作成されていません',
    emptyMessage2: '下をクリックしてプロジェクトを作成',
    emptyMessage3: '生成を開始する',
    emptyMessage4: 'まだ画像が保存されていません。生成して',
    emptyMessage5: '画像を追加するために保存',
    emptyMessage6: 'まず新しいプロジェクトを作成し、プロジェクト内で生成して',
    emptyMessage7: 'LOOKを保存',
    createProjectButtonText: '新規プロジェクト',
    projectNamePlaceholder: 'プロジェクト名を入力してください',
    projectEnterText1: 'プロジェクトに入る',
    projectEnterText2: 'ワークスペースに入る',
    createProjectTip: 'まずプロジェクトを作成してください'
  },
  image: {
    text2ImageTitle: 'テキストから画像生成',
    originalityTitle: 'スケッチから画像生成',
    styleExtensionTitle: 'スタイル拡張',
    styleFuseTitle: 'スタイルブレンド',
    tuneTitle: 'エリア調整',
    recolorTitle: 'スマート着色',
    backgroundTitle: 'AI シーン変更',
    eraserTitle: 'マジック消去',
    cutoutTitle: 'ワンクリック抜き取り',
    flowerPatternExpansionTitle: 'シームレス タイル',
    aiExpansionTitle: 'AI拡張',
    hdTitle: '高画質化',
    drawingTitle: 'Real-Time Design',
    patternTitle: 'パターンマッピング',
    imageCount: '枚',
    generateButtonText: 'LOOKを生成',
    generateButtonSubscribeBoxTitle1: '初回購読者限定50%オフ',
    generateButtonSubscribeBoxTitle2: 'プロ版をアンロック',
    generateButtonSubscribeBoxDesc1:
      '無料トライアルが終了しましたか？今すぐ割引価格で生成特権をアンロック！',
    generateButtonSubscribeBoxDesc2: 'プロ版にアップグレードして、Real-Time Designの自由を実現！',
    generateButtonSubscribeBoxButtonText1: '今すぐ取得',
    generateButtonSubscribeBoxButtonText2: 'Pro 版にアップグレード',
    originalSizeText: '元の比率',
    uploadImageButtonText: '画像をアップロード',
    uploadPatternButtonText: 'パターンをアップロード',
    editMaskButtonText: 'マスクを編集',
    removeMaskButtonText: 'マスクを削除',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">クリックまたはドラッグしてアップロード</span><br/> <span style="color: #b0b2ae; font-size: 12px">(下部と右側の保存エリアの画像は直接ドラッグ可能)</span>',
    generatePreviewText: 'プレビューを生成({count}/{max})',
    previewListHelpMessage1:
      '生成された画像はこのリストに一時的に保存され、最大{max}枚まで保存できます。{max}枚を超えると、最初に生成された画像が削除されます',
    previewListHelpMessage2:
      '一時画像はアルバムに保存されて初めて永久保存され、さらに操作が可能になります。',
    clearPreviewButtonText: 'すべてのプレビューをクリア',
    segmentErrorMessage: '画像のセマンティック解析に失敗しました。もう一度お試しください',
    generatingMessage: '画像生成中',
    previewWaitingMessage: '画像処理中です。しばらくお待ちください',
    previewFailedMessage: '画像処理に失敗しました。表示できません',
    imageInQueueMessage: 'キュー待ち',
    imageNotVerifyMessage: '不適切内容',
    saveImageButtonText: 'アルバムに保存',
    deleteTmpImageButtonText: '一時的な画像を削除',
    previewImageInfoText: '画像情報',
    promptDefaultPlaceholder: '設計の説明や説明のプロンプトを入力して生成の精度を高める',
    promptDefaultPlaceholder2: 'パターンの説明を入力してください',
    promptDefaultPlaceholder3: '画像の説明を入力してください',
    promptDefaultPlaceholder4: 'モデルの説明を入力してください',
    removeBgErrorMessage: '背景の削除に失敗しました',
    removeBgButtonText: '背景を削除',
    removeBgLoadingMessage: '背景を削除しています。しばらくお待ちください',
    cropTip1:
      '画像の上下にできるだけ多くのスペースを確保して、モデルの頭部と脚部を生成してください',
    cropTip2: 'アップロードした画像が小さすぎる場合は、適切なサイズにトリミングしてください',
    diyModelText: 'カスタムモデル',
    commonModelText: '公開モデル',
    exclusiveModelText: '専用モデル',
    promptTitle: 'プロンプト',
    promptTitle2: '花型説明',
    promptTitle3: '画像説明',
    promptTitle4: 'モデル説明',
    promptInputTitle: 'デザイン特徴（複数選択可）',
    selectModelTitle: 'モデル選択',
    referenceStrengthLabel: '参考強度',
    modelSettingTitle: 'モデル設定',
    advancedSettingsTitle: '高度設定',
    negativePromptTitle: '反対のプロンプト',
    negativePromptPlaceholder: '画像に含めたくない要素を入力または選択',
    generateCountTitle: '生成枚数',
    cleanerTitle: '前景を削除',
    maskSwitchViewButtonText: 'ビューを切り替える',
    regenerateButtonText: '再生成',
    imageLoadingMessage: '画像を読み込み中',
    maskGenerateFailedMessage: 'マスクの作成に失敗しました',
    maskPreviewDialogConfirmButtonText1: '切り抜きを確認',
    maskPreviewDialogConfirmButtonText2: 'マスクを作成',
    maskPreviewDialogCancelButtonText: '編集を続ける',
    objectRemovalDialogCancelButtonText: '編集を続ける',
    objectRemovalFailedMessage: '前景の削除に失敗しました',
    magicMaskGenerateFailedMessage: 'スマートマスクの作成に失敗しました',
    partMaskDialogTitle: '部分選択',
    imageAnalyzingMessage: '画像を分析中',
    cutout: '切り抜き',
    maskDialogConfirmButtonText1: 'プレビューを準備中',
    maskDialogConfirmButtonText2: 'プレビュー生成',
    maskDialogConfirmTip: 'フリーズしましたか？もう一度お試しください！',
    rangeOfChangeLabel: '変化幅',
    lesser: '小さく変化',
    more: '大きく変化',
    disableModelDesc: 'モデルを無効にして、スケッチにモデルが含まれていないことを確認してください',
    generateFailedMessage: '画像生成タスクの作成に失敗しました',
    taskNotEnoughTip: '最大同時生成タスク数に達しました。後でもう一度お試しください',
    saveTip1: '{saveType}を保存すると、画像を保存した後に自動的にクリア処理が実行されます。',
    saveTip2:
      '現在のLOOKと{saveType}のタスク総数が最大同時実行タスク数に達している場合、{saveType}の保存操作は一時的に利用できません。',
    promptButtonText1: 'AI 潤色',
    promptButtonText2: '画像の説明',
    promptButtonMessage: 'まずはプロンプトを入力してください',
    promptButtonFailMessage: '生成に失敗しました。もう一度お試しください',
    colorMatchTitle: '色彩還原',
    colorMatchSubject: 'ファッションイラストを写真に',
    colorMatchDesc: '生地の本来の色と質感を表現',
    patternExpansionSize: '拡張サイズ',
    patternExpansionSizeSmall: '小さい',
    patternExpansionSizeMedium: '中くらい',
    patternExpansionSizeLarge: '大きい',
    flowerPatternExpansionStep1: '1.非四方連続のパターンをアップロード',
    flowerPatternExpansionStep2: '2.拡張する範囲を選択',
    flowerPatternExpansionStep3:
      '3.LOOKはパターンのエッジを拡張し、元のパターンを連続パターンに変換します。保存またはダウンロードして、後でデザインに使用できます。',
    maskCreateText: 'マスクを作成'
  },
  cleaner: {
    maskDialogTitle: '消去する領域を選択',
    maskDesc: '削除する領域を選択してください'
  },
  drawing: {
    generatingMessage: '生成中です。しばらくお待ちください',
    startDrawingMessage: '描き始めてください',
    waitingScreenMessage: 'スクリーンミラーリングを待っています... ',
    canvasCropperGuideMessage: 'LOOK で画面をキャンバスサイズにトリミングしてください',
    startDrawingButtonText: 'デザインを開始',
    stopDrawingButtonText: '描画中、クリックして停止',
    videoNotSupportMessage: '現在のブラウザはビデオ再生をサポートしていません',
    canvasGuideMessage1:
      'iPadで <img src="{image}" width="26" height="26" /> Procreateを起動し、キャンバス配信を再設定してください',
    canvasGuideMessage2: '注意：キャンバス配信を一度オフにしてから再度オンにしてください',
    castScreenGuideMessage1: '現在のバージョンは',
    castScreenGuideMessage2: ' Procreate 投影',
    castScreenGuideMessage2After: 'のみ対応しています',
    castScreenGuideMessage3:
      '{placeholder}のガイドに従ってiPadの画面ミラーリング接続を開いてください',
    castScreenGuideMessage4: '（2台のデバイスは同一ネットワーク内にある必要があります）',
    screenPreviewTitle: 'スクリーンミラーリングプレビュー',
    reCropButtonText: '再クロップ'
  },
  hd: {
    scaleTitle: '画質を向上させる',
    imageClaritySD: '保存',
    imageClarityHD: '高画質で保存',
    imageClarityUHD: '超高画質で保存',
    imageClarityTextSD: '標準画質',
    imageClarityTextHD: '高画質',
    imageClarityTextUHD: '超高画質',
    generatingMessage: '拡大中'
  },
  matte: {
    maskDialogTitle: '保持する領域を選択',
    maskDesc: '保持するエリアを選択してください',
    magicLabel: 'スマート切り抜き'
  },
  originality: {
    lineDrawingTitle: 'スケッチ',
    lineDrawingUploadTitle: 'スケッチのアップロード',
    sampleClothesTitle: 'サンプル服'
  },
  recolor: {
    maskDialogTitle: '色を変更する領域を選択',
    maskDesc: '色を変更する領域を選択してください',
    colorSelectTitle: '色の選択',
    getColorWarningMessage: '現在のブラウザはスポイト機能をサポートしていません'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'デザイン画像'
  },
  background: {
    maskDialogTitle: '保持する領域を選択',
    maskDesc: '保持するエリアを選択してください',
    backgroundDialogTitle: '背景を追加',
    backgroundDescTitle: '背景説明',
    promptInputPlaceholder: '背景の説明を入力して生成精度を向上させます',
    referenceBackgroundTitle: '参考背景',
    intelligentFillLightLabel: 'スマートライト',
    backgroundGenerateTimeoutMessage: '背景の生成がタイムアウトしました。もう一度お試しください',
    backgroundGenerateFailedMessage: '背景の生成に失敗しました。もう一度お試しください',
    addBackgroundTitle: '背景を追加',
    backgroundSizeTitle: '背景のサイズ',
    effectPreviewMessage: '効果プレビュー',
    canvasEmptyMessage: 'まず背景を追加してください'
  },
  text2Image: {
    textExampleMessage1:
      'イタリア人モデルがオーバーサイズのニットウェアを着たルックブックの写真です。人物のクローズアップ。異なる色の糸で織られたチェック柄のニットセーターを着ています。ファッションブランドのアウトドアウェア、ストリートウェアで、キャンベル・アディのスタイルで撮影されたファッション写真です。',
    textExampleMessage2:
      'ファッショナブルな中国人モデルが、モダンな中国風のスタイルで、流れるようなロングドレスを着ています。低彩度の衣装に同系色のプリントが施されています。上海ファッションウィークのランウェイで、現代のファッション感覚を持つ衣装を披露しています。',
    textExampleMessage3:
      'ファッションモデルのクローズアップ、衣装は構造的な分割を特徴とし、モダンな服装で、シンプルで清潔感があり、流れるようなデザイン。シルクとリネンの生地が混ざり合った服装で、ファッション雑誌の表紙にぴったりです。',
    textExampleMessage4:
      'ファッショナブルなモデルが、精巧な刺繍が施された白いシャツを着ています。シャツには、大きな暗赤色の花柄と金色の刺繍のディテールがあり、ヴィンテージのエレガンスを添えています。モデルは金色の丸いイヤリングをつけており、髪は整えられ、後ろにすっきりと梳かれ、顔が露出しています。背景は深い緑色で、モデルの肌の色と服装を際立たせ、全体のイメージに強い芸術性を与えています。写真の色調は柔らかく、低彩度で、静かで詩的な雰囲気を醸し出しています。',
    textExampleMessage5:
      'ファッションモデルのソロ、明るいオレンジのルーズセーターを着ており、厚手のニット素材で作られ、高い襟のデザインとわずかにゆったりした袖が特徴です。ボトムスは光沢のあるしっかりとした質感のダークブルーのAラインレザースカートを着用。厚底のハイヒールを履き、重厚感を出しています。オレンジ色のフレームに青いレンズのサングラスを合わせ、全体のスタイリングに未来的で劇的な印象を与えます。高彩度の色彩で強いコントラストを持ち、鮮明で大胆な視覚効果を生み出しています。アクセサリーとメイクアップは独特で誇張されており、個性と芸術性を強調しています。背景はシンプルです。',
    textExampleMessage6:
      '若いファッショナブルな女性が黄色の蛍光ジャケットを着て、日本の街頭に立っている。青い空、自然光、上半身ショット',
    textExampleMessage7:
      'エレガントな白人女性モデルが、ダークグレーのミニマリストVネックのロングコートとマーチンブーツを履いています。Theo Angelopoulosのスタイルで撮影されたもので、ブランドLemaireのカシミア生地で作られたコートで、しわがあり、オーバーラップのフロントプラケットが特徴です。静かな神聖な雰囲気を醸し出し、霧の中の森が背景となっています。',
    textExampleMessage8:
      '大胆な緑色のニットセーターを着たファッショナブルな女性、背景は紫色です。セーターには、抽象的な顔に見える白と青の要素を含む独特のデザインが施されています。生地は厚手の編み物で、ウールまたはウール混紡の素材である可能性があり、このタイプの衣服には通常、暖かさと質感を実現するために使用されます。フィット感はゆったりとしており、袖は手首を超えて伸びており、カジュアルでオーバーサイズです。鮮やかな緑が全体の外観を支配し、黒いパンツと対照的で、目を引く色の組み合わせを作り出しています。全体のスタイルはアバンギャルドで、現代のストリートファッションの範疇にあります。',
    textExampleMessage9:
      '韓国のファッションインフルエンサーが、袖が広いゆったりとしたライトブルーのデニムシャツを着ています。シャツには複数の裂け目や色あせた部分があり、ビンテージスタイルを示唆しています。モデルは、シャツにマッチするライトカラーのショートパンツを着用しており、おそらくデニム素材です。彼女はまっすぐな黒い長髪を持ち、中立的な表情で前方を見つめています。背景はライトグレーで、服装を強調しています。フィルムの質感があります。',
    textExampleMessage10:
      '韓国のモデルがシンプルな背景の前に立っています。彼女は、フード付きのオーバーサイズの淡いオリーブグリーンのニットカーディガンを着ており、とても快適でカジュアルな印象を与えます。カーディガンは厚手のニット生地でできており、立体的な幾何学模様が特徴です。フィット感はゆったりとしており、秋冬の着用に適しています。モデルは、ロゴがはっきりと見える濃い茶色の野球帽もかぶっています。彼女の表情は中立的で、視線は横向きに向けられており、リラックスした感じを醸し出しています。全体的なスタイルはカジュアルでファッショナブルなもので、快適さと現代性を強調しています。写真はフィルムのような質感を持っています。',
    textExampleMessage11:
      'モデルが中立的な背景の前に立っています。彼女は、広い袖と非対称の裾のデザインを持つ独特のオフホワイトの服を着ており、複数の層の生地が積み重ねられ、中国風のスタイルを示しています。生地は柔らかく流動的で、テクスチャーがあり、おそらく軽量のコットンまたはシルクの混紡で作られています。フィット感はゆったりしており、快適でスタイリッシュな現代的な外観を提供します。服装は主にオフホワイトで、黒いパンツが対比を提供しています。全体的なスタイルはミニマリズムに傾いており、優雅さが加えられています。モデルは清潔な外見で、シンプルなヘアスタイルと穏やかな表情が、全体のルックに落ち着きと自信を加えています。',
    generationRatioTitle: '生成比率',
    tryText: '試してみる',
    freeProportionText: '自由比率'
  },
  tune: {
    maskDialogTitle: '変更する領域を選択',
    maskDesc: '変更するエリアを選択してください',
    promptTitle: '画面説明'
  },
  pattern: {
    maskDialogTitle: '貼り付ける領域を選択',
    maskDesc: '貼り付けるエリアを選択してください',
    assistImagesTitle: 'パターン'
  },
  modelTryOn: {
    modelImageDialogTitle1: 'モデルをアップロード',
    modelImageDialogTitle2: '衣装をアップロード',
    maskDesc: '着替えが必要な領域を塗りつぶしてください',
    maskDialogTitle: '着替えが必要な領域を塗りつぶしてください',
    upperBodyTitle: '上装/ドレス',
    dressTitle: '下装',
    loadingText: '選択中，少々お待ちください...',
    errorText: '選択に失敗しました。もう一度お試しください',
    upperBodyMaskDialogTitle: '上装/ドレスの領域を選択',
    dressMaskDialogTitle: '下装の領域を選択',
    singleMaskDialogTitle: 'モデルの領域を選択',
    single: '単一アイテム',
    multi: '複数アイテム',
    singleTitle: '単一アイテム'
  },
  modelFace: {
    uploadImageTitle: '原画像をアップロード',
    maskDialogTitle: '人物の顔の領域を塗りつぶしてください',
    maskDesc: '人物の顔の領域を塗りつぶしてください',
    selectModelTitle: 'モデルを選択',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">モデルを選択</span>',
    headSize: '頭部サイズ'
  },
  diyModel: {
    sex: '性別',
    male: '男性',
    female: '女性',
    age: '年齢',
    kid: '子供',
    juvenile: '大人',
    adult: '10代',
    youth: '若者',
    middleAged: '中年',
    elderly: '高齢',
    color: '肌色',
    bodyShape: '体型',
    hair: '髪',
    length: '長さ',
    hairstyle: '髪型',
    slenderBody: 'スリム',
    hourglassBody: '均一',
    muscularBody: '筋肉質',
    babyFatBody: '赤ちゃん肥満',
    shortAndFatBody: '矮胖',
    curvaceousBody: '曲線美',
    straight: 'ストレートヘア',
    wavy: 'ウェーブヘア',
    curly: 'カールヘア',
    braided: '編み込み髪',
    naturallyCurly: 'ナチュラルカール',
    updo: '巻き髪',
    airBangs: 'アップヘアスタイル',
    dreadlocks: '空気バング',
    ponytail: 'べたつきバング',
    bald: 'ポニーテール',
    centerPartedHair: 'ノーゲーム',
    bangs: '分け目ヘアスタイル',
    frontBangs: 'ヘビーバング',
    short: '短髪',
    long: '長髪',
    shoulderLength: '肩にかかる髪',
    extraLongHair: '超ロングヘア',
    pixieCut: '耳にかかる短髪',
    collarboneLengthHair: '肩までの髪',
    shoulderLengthHair: '肩ひじ髪',
    waistLengthHair: '腰までの髪',
    fairSkinWhite: '白い肌',
    darkSkin: '黒い肌',
    yellowSkin: '黄色の肌',
    asian: 'アジア人',
    european: 'ヨーロッパ人',
    african: 'アフリカ人',
    american: 'アメリカ人',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: 'マウスクリックで保持する領域を選択',
    matte:
      '画像をアップロードし、保持する領域をマウスでクリックします。切り抜きが不要な場合は、直接「確定」ボタンをクリックしてください',
    cutout: 'マウスクリックで保持する領域を選択',
    part: 'マウスクリックでマスクにする領域を選択',
    objectRemoval:
      '前景の一部を削除するには、「前景を削除」をクリックして、削除する領域をマウスでクリックします。不要な場合は、「確定」ボタンを直接クリックしてください'
  },
  subscribe: {
    subscribeTitle:
      '初回購読特典&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}%オフ</span>&nbsp;割引',
    subscribeTitleFree:
      '<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7日間の無料メンバーシップ</span>を獲得',
    person: '人',
    month: '月',
    year: '年',
    currency: '$',
    mostPopularText: '最も人気',
    noMemberText: 'メンバーシップなし',
    subscribeSubText:
      'メンバーシップ期限切れ後に自動更新され、<span style="color: #0d0d0d">翌月は通常価格に戻ります</span>、いつでもキャンセル可能です',
    subscribeSubTextFree: 'サブスクリプションはいつでもキャンセルでき、追加料金はかかりません',
    priceNegotiableText: '営業に連絡',
    tryThisText: '最も人気',
    payButtonText1: '購読',
    payButtonText1Free: '$0.00 7日間無料メンバーシップを受け取る',
    payButtonText2: '購読',
    payButtonText3: 'プランアップ',
    payButtonText4: '現在の定期購読',
    payButtonText5: 'おじあく様サポート',
    payButtonText6: 'サブスク編集',
    payButtonText7: '購読',
    payMessage1: 'は無料試用終了後のプランです',
    payMessage2: '開通中',
    payMessage3: '15日間の試用終了後に支払い',
    payMessage4: '支払う',
    payMessage5: 'QRコードをスキャンして支払いを完了してください',
    payMessage6: '期限が切れると {currency}{amount}/月 で自動更新され、いつでもキャンセル可能です',
    payMessage7:
      '体験が終了すると、{currency}{amount}/月 で自動更新され、いつでもキャンセル可能です',
    payMessage8: '契約を完了するためにQRコードをスキャンしてください',
    paySuccessText: 'サブスクリプション成功',
    paySubText: '開通は同意を意味します',
    freeMemberSuccessDesc:
      '15日間の会員体験終了後に料金が差し引かれます。サブスクリプションはいつでもキャンセル可能で、追加料金はかかりません',
    receiveAwardTitle: '🎉LOOKへようこそ！',
    receiveAwardTitleTaskGuide: '🎉1日間の無料トライアルを受け取りました！',
    receiveAwardSubject:
      '私たちはあなたのために<br><span style="font-size: 24px; font-weight: 700">{number}日間の無料試用</span>&nbsp;を準備しました',
    receiveAwardSubjectTaskGuide:
      'LOOKの主要機能を簡単に体験',
    receiveAwardTip: '足りない？',
    receiveAwardButtonTextTaskGuide: '体験する',
    receiveAwardButtonText: '{currency}0.00で{number}日間の無料トライアル',
    memberInvitedOnly: '招待のみ',
    memberTipsStarter: '個人デザイナーやAI初心者に最適です。',
    memberTipsPlus: '高度なAIツールが必要な経験豊富なデザイナー向けです。',
    memberTipsPro: '完全なAI機能とプレミアム機能を求めるプロ向けです。',
    memberFreeDesc1Label: '生成画像数',
    memberFreeDesc1Value: '8枚/日',
    memberFreeDesc2Label: '解像度',
    memberFreeDesc2Value: '標準',
    memberFreeDesc3Label: '同時タスク数',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: 'なし',
    memberDescStarter0Label: '生成張数',
    memberDescStarter0Value: '無限制',
    memberDescStarter1Label: '生成速度',
    memberDescStarter1Value: 'ノーマル',
    memberDescStarter2Label: '同時生成',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: '生成頻度',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: 'アップスケール頻度',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: '画像品質をアップスケール',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: '生成張数',
    memberDescPlus0Value: '無限制',
    memberDescPlus1Label: '生成速度',
    memberDescPlus1Value: '速い',
    memberDescPlus2Label: '同時生成',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: '生成頻度',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: 'アップスケール頻度',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: '画像品質をアップスケール',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: '生成張数',
    memberDescPro0Value: '無限制',
    memberDescPro1Label: '生成速度',
    memberDescPro1Value: 'ターボ',
    memberDescPro2Label: '同時生成',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: '生成頻度',
    memberDescPro3Value: '無制限',
    memberDescPro4Label: 'アップスケール頻度',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: '画像品質をアップスケール',
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: '無制限',
    stripeConfirmMessage1: '購読中',
    stripeConfirmMessage2: '購読が成功したか確認してください',
    stripeConfirmMessage3:
      'カードが有効であることを確認するために、{currency}1の事前承認を行います。',
    stripeConfirmMessage4:
      'これは確認のためだけで、<span style="font-weight: 600; color: #0d0d0d">実際の請求は発生しませんので</span>、ご安心ください。',
    stripeSuccessMessage: '購読が完了しました！',
    stripeFailedMessage:
      '確認に失敗しました。もう一度お試しいただくか、別の支払い方法をご利用ください。',
    stripeConfirmButtonText: '購読完了',
    stripeCancelButtonText: 'キャンセルする',
    stripeEditBillingMessage: '請求情報のサブスクリプションが編集されています…',
    stripeEditBillingConfirmButtonText: '完了する',
    stripeUpgradeMessage: 'サブスクリプションをアップグレードしてもよろしいですか？',
    stripeUpgradeSuccessMessage: 'アップグレード成功！',
    stripeSubscribeRenewButtonText: '購読を再開',
    stripeSubscribeRenewConfirmMessage: '自動更新を再開してもよろしいですか？',
    stripeSubscribeRenewSuccessMessage: '購読を再開しました',
    stripeSubscribeCancelButtonText: '解約',
    stripeSubscribeCancelConfirmMessage: '自動更新をキャンセルしてもよろしいですか？',
    stripeSubscribeCancelSuccessMessage: '購読を解約しました',
    cancelQuestionaireTitle: '退会理由を選択してください（単一選択）',
    cancelQuestionaireSubject:
      '解約の理由を把握するため、以下の選択肢からお選びください。（単一選択）',
    cancelQuestionaireSelection1: 'ただ解約したいから',
    cancelQuestionaireSelection2: '価格が高すぎる',
    cancelQuestionaireSelection3: 'サービス内容が自分のニーズに合わなくなった',
    cancelQuestionaireSelection4: '使い勝手が悪い',
    cancelQuestionaireSelection5: '技術的な問題（例：頻繁なエラーや中断）',
    cancelQuestionaireSelection6: 'より良い代替品を見つけた',
    cancelQuestionaireSelection7: 'その他（ご記入ください）',
    cancelQuestionaireSelection8: 'より良いもの',
    cancelQuestionaireSubmiteButtonText: '送信',
    cancelQuestionaireCancelButtonText: 'もう少し使います',
    cancelSuccessMainTitle: 'サブスクリプションがキャンセルされました',
    cancelSuccessSubject: 'まもなく確認のメールが届きます',
    reactivateTitle: 'キャンセルするつもりはなかったですか？',
    reactivateSubject: 'ご心配なく、再アクティベートしましょう！',
    reactivateButtonText: '今すぐ再アクティベート',
    upgradeTitle: 'アップグレードプラン',
    upgradeSubject: 'あなたのサブスクリプションのアップグレードは即座に有効になります。',
    upgradeDesc: '料金は今月の残りの日数に基づいて按分され、新しいプランの料金から差し引かれます。',
    qrcodeTimeout: '二維碼がタイムアウトしました',
    clickToRefresh: 'クリックして再試行',
    cycleText: '月次課金',
    yearlyText: '年次課金',
    paymentTypeMonthlyText: '月次課金',
    paymentTypeYearlyText: '年次課金',
    freeUsageText: '今日の残りの無料使用回数：{count}',
    currentSubscription: '現在のサブスクリプション',
    expiredText: '更新日: {date}'
  },
  similer: {
    similerTitle: '視覚検索',
    similerWaitingMessage: 'コンポーネントは初期化中です。しばらくお待ちください',
    similerSearchFailedMessage: '検索に失敗しました。クリックして再試行してください',
    similerNoSimilarMessage: '類似の画像は見つかりません',
    similerLoadingMoreDetailImageError:
      '高清画像の読み込みに失敗しました。クリックして再試行してください'
  },
  taskType: {
    generate: '画像生成',
    upscale: 'アップスケール',
    realtimeDesign: 'Real-Time Design'
  },
  rewardTask: {
    rewardTaskListTitle1: '8日間無料トライアルを取得',
    rewardTaskListTitle1Intl: '主要機能を試す',
    rewardTaskListDesc1: '電話番号を連携する',
    rewardTaskListGuide1: '電話番号を連携する',
    rewardTaskListDesc2: 'プロジェクトを作成',
    rewardTaskListGuide2: 'プロジェクトを作成',
    rewardTaskListDesc3: 'スケッチから画像生成',
    rewardTaskListGuide3:
      '画像をクリックまたはドラッグしてアップロードし、スケッチ、スタイル画、ファッションイラスト、実写を現実的な効果に変換します。',
    rewardTaskListDesc4: 'スケッチから画像生成（色彩還原）',
    rewardTaskListGuide4:
      'スケッチから画像生成で、<span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">色復元</span> <img src="{img}" style="vertical-align: middle;" />をオンにすると、元の色を参照します。オフにすると、ランダムに色が生成されます。',
    rewardTaskListDesc5: 'スタイル拡張',
    rewardTaskListGuide5:
      'スタイル拡張機能では、アップロードした衣服画像をもとに、AIが素早くバリエーションのシリーズを作成できます。',
    rewardTaskListDesc6: 'スタイルブレンド',
    rewardTaskListGuide6:
      'スタイルブレンドでは、2つの画像をアップロードして衣服とインスピレーション素材を融合させ、異なるファッションスタイルの融合を生み出します。',
    rewardTaskListDesc7: 'テキストから画像生成',
    rewardTaskListGuide7:
      'デザインの説明を入力してLOOKを生成します。<img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> AIポリッシュと画像説明を使用して、説明文を書くのに役立ちます。',
    getRewardButtonText1: '完了',
    sketchToImageInitPrompt:
      '美しいモデルが、大きなプリーツと波のあるルーズなスカートを持つアシンメトリックなオフショルダーのガウンを着ています。光沢のある生地で作られており、ダークカラーのポインテッドトゥヒールと合わせています。このドレスは、わずかにメタリックな光沢のある生地で、エレガントさとモダンさを醸し出しています。',
    sketchToImageColorInitPrompt:
      'シルバーグレーのリネンロングスカート、黒のタートルネックセーター、暖かい黄色のチェック柄ベストという優雅な衣装を着たモデルのファッション写真。厚底のブーツと、大きなリボンが付いた暖かい黄色と黒のチェック柄ベルトが含まれています。ベストとスカートには幾何学模様が施されています。彼女の髪は額の上で高く梳かれており、サングラスをかけています。全身ショット。',
    styleExtensionInitPrompt:
      '白い背景の上に、シャープなラペルと非対称なポケットのディテールを備えた構造的なクロップドブレザーを特徴とするハイファッションの衣装。このブレザーは、レイヤードパネルと流れるような非対称の裾を特徴とする、ドレープのかかったハイウエストスカートと組み合わされています。このデザインは、仕立ての精密さと流動的なドレープを組み合わせたアバンギャルドなシルエットを強調しています。素材は、コットンやコットンブレンドなどの軽量でマットな生地で、柔らかさと構造性を兼ね備えた外観を実現しています。落ち着いたアースグリーンの色調が、ミニマリストで現代的な美意識を高めています。全体的なデザインは、現代的な仕立てとアーティスティックな流動性のバランスを反映しており、ランウェイやエディトリアルファッションに最適です。プロダクト写真、詳細なテクスチャー。',
    styleFusionInitPrompt:
      '白い背景に、胸元に立体的な編み込みのリボン模様が施された、ボリュームのあるカラフルなニットセーター。',
    text2ImageInitPrompt:
      '黒い肌のモデルが、オーバーサイズのブレザーとレザースカートを着用し、ヒールの後ろに大きなリボンが付いたブーツを履いた長い脚で、白い背景に対してVogueファッション写真のようなポーズをとっています。画像はハイパーリアルです。',
    limitTime: '限時  ',
    guideStartButtonText: '生成する',
    confirmCloseDialogTitle: 'チュートリアルをスキップ',
    confirmCloseDialogDesc:
      'チュートリアルをスキップしてもよろしいですか？後で見ることはできません。',
    confirmCloseDialogCancelButtonText: 'キャンセル',
    confirmCloseDialogConfirmButtonText: 'はい、スキップ',
    rewardTitle: 'あなたのデザインのブーストが待っています！',
    rewardDescription: 'あなたのクーポンを使用して、新しい、強力なデザイン機能を探索してください。',
    couponType1: '割引券',
    couponType2: 'メンバー券',
    expiredText: '有効期間：',
    useNow: '今すぐ使用！'
  },
  contextMenu: {
    copy: 'コピー',
    paste: '貼り付け',
    selectAll: '全選択'
  },
  login: {
    success: 'こんにちは、デザイナー！',
    closeWindow: 'ログインに成功しました。このウィンドウを閉じることができます。'
  },
  update: {
    updateDialogTitle: '更新',
    updateDialogMessage: '新しいバージョンが利用可能です。更新しますか？',
    updateDialogCurrentVersion: '現在のバージョン',
    updateDialogNewVersion: '新しいバージョン',
    updateDialogCancelButtonText: '今はしない',
    updateDialogUpdateButtonText: '更新',
    updateDialogUpdateButtonLoadingText: '更新中...'
  },
  updateError: {
    updateErrorDialogTitle: '更新',
    updateErrorDialogMessage: '新しいバージョンが利用可能です。更新しますか？',
    updateErrorDialogButtonText: '更新'
  },
  updateProgress: {
    updateProgressDialogTitle: '更新中...'
  },
  remainingBalance: {
    realTimeDesign: 'リアルタイムデザイン時間',
    minute: '分',
    hour: '時間',
    frequency: '頻度',
    upscale: 'アップスケール',
    last: '残り',
    image: '画像',
    unlimited: '無制限'
  },
  compositor: {
    opacity: '不透明度',
    saturation: '彩度',
    brightness: '明度',
    contrast: 'コントラスト',
    hue: '色相',
    depthMapFailed: '深度図生成に失敗しました。再度アップロードしてください'
  },
  coupon: {
    couponListTitle: 'クーポン',
    couponExpireCountdown: '残り時間：',
    couponExpire: '有効期間：',
    couponListEmpty: 'クーポンはありません',
    couponListEmptyDescription1: 'LOOKの公式Discordチャンネルに参加',
    couponListEmptyDescription2: 'アクティビティに参加して素晴らしいプレゼントを獲得！',
    couponListEmptyButton: 'Discordに参加'
  },
  plugins: {
    pluginsTitle: 'プラグイン市場',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: 'プラグイン画像なし',
    noPluginComponentText:
      'プラグインページが見つかりません。プラグインが正しく設定されていることを確認してください',
    editPluginsButtonText: 'プラグイン編集',
    editPluginsCompletedButtonText: '編集完了',
    morePluginsButtonText: 'もっと多くのプラグイン',
    removePluginTipsTitle: 'プラグインを削除',
    removePluginTips1: '削除されたプラグインは',
    removePluginTips2:
      '<span style="color: #0d0d0d; font-weight: 600;">プラグイン市場</span> 内で再び追加できます',
    pluginDisabled: 'プラグインは利用できません',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: 'プラグイン市場が登場！',
      plugintipTitle1: '機能集合：',
      plugintipDesc1:
        '我們把原本分散的實用小功能，「智能换色」「AI换场景」「魔术擦除」「一键抠图」等，全部打包进插件市场，只要去插件市场Pin一下，熟悉的功能秒回来',
      plugintipTitle2: 'インターフェースDIY：',
      plugintipDesc2:
        '進入插件市場 > 添加插件 > 在左側工具欄點擊「編輯插件」，上下拖動插件圖標，想怎麼排就怎麼排！你的LOOK你做主',
      plugintipTitle3: 'プラグインをもっと欲しい？',
      plugintipDesc3:
        'ご要望や使用LOOKの感想、改善要望など、LOOKはあなたの声をお待ちしています。ぜひお聞かせください。'
    },
    pluginsTipsFooter: {
      discord: 'Discordコミュニティに参加',
      instagram: 'Instagramで見る',
      email: 'メールを送信：{email}'
    }
  }
}

export default ja as any
